import { createSlice } from '@reduxjs/toolkit';
import { LoadAnnouncements } from './load-announcements.thunk';
import { AnnouncementsState } from './announcements.state';

const initialState: AnnouncementsState = {
    announcements: [],
    isLoading: false,
    status: 'loading',
    error: '',
};

const announcementsSlice = createSlice({
    name: 'announcements',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(LoadAnnouncements.pending, (state) => setPendingState(state))
            .addCase(LoadAnnouncements.fulfilled, (state, action) => {
                if (!action.payload?.data?.data) {
                    setRejectedState(state);
                    return;
                }
                state.announcements = action.payload.data.data;
                setSucceededState(state);
            })
            .addCase(LoadAnnouncements.rejected, (state) => setRejectedState(state));
    },
});

const setRejectedState = (state: any) => {
    state.isLoading = false;
    state.status = 'failed';
    state.error = state;
};

const setPendingState = (state: any) => {
    state.isLoading = true;
    state.status = 'loading';
    state.error = '';
};

const setSucceededState = (state: any) => {
    state.isLoading = false;
    state.status = 'succeeded';
    state.error = '';
};

export const {} = announcementsSlice.actions;
export default announcementsSlice.reducer;
